import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Typography,
} from "@material-ui/core";
import React from "react";
import RelatedGenes from "./relatedGenes";
import { useTranslation } from "react-i18next";

function PopUpGenes({
  genes,
  dialogData,
  setDialogData,
  open,
  setOpen,
  selectPanelAppFilter,
  handleDialogClose,
  classes,
  handleOnDelete,
  relatedGenesOnClick,
  setOriginalDialogData,
  originalDialogData
}) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={handleDialogClose} maxWidth="lg">
      <DialogTitle id="alert-dialog-title">
        <Typography variant="h3">{genes[0]}</Typography>
        <Divider style={{ marginTop: "10px" }} />
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Box display="flex" style={{ gap: 10 }} flexWrap="wrap">
            {Object.entries(genes[1]).map((value, index) => (
              <RelatedGenes
                key={index}
                value={value}
                onClick={() => relatedGenesOnClick(value)}
              />
            ))}
          </Box>
          <Divider style={{ margin: "10px 0" }} />
          <Box style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            {Object.entries(genes[1]).map(
              (value) =>
                value[1].isActive &&
                value[1].genes.map(
                  (gene, index) =>
                    gene.isActive && (
                      <Chip
                        key={index}
                        color={value[1].color}
                        label={<Typography style={{ mixBlendMode: "lighten" }}>{gene.label}</Typography>}
                        variant="outlined"
                        onDelete={() => handleOnDelete(genes[0], value[0], gene.label)}
                        style={{ 
                          // color: value[1].color,
                          // mixBlendMode: "difference",
                          backgroundColor: value[1].color }}
                      />
                    )
                )
            )}
          </Box>
        </DialogContentText>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => {
              if (originalDialogData) {
                setDialogData(JSON.parse(JSON.stringify(originalDialogData)));
              }
              handleDialogClose();
            }}
          >
            {t("Cancel")}
          </Button>

         <Button
          color="primary"
          variant="contained"
          onClick={() => {
            if (dialogData) {
              selectPanelAppFilter(dialogData); 
              setOriginalDialogData(JSON.parse(JSON.stringify(dialogData))); 
              handleDialogClose();  
            }      
          }}
        >
          {t("Apply")}
        </Button>


        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}

export default PopUpGenes;
